export const EditorDocumentAdded = 'Editor Document Added';
export const EditorModified = 'Editor Modified';
